export default "__VITE_ASSET__592bfe25__"